module.exports = __webpack_public_path__ + "img/fourthimage.5cd2abf0.png";